import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

import { BuergscheinCreateSuper } from './bgsch-create.super';
import { CreateBuergscheinModel } from '../../../../model.module/create-buergschein.model';
import { ConfigurationApiService } from '../../../../../generated/api/configuration/configuration.service';

@Component({
    selector: 'bgsch-create-abschl-2',
    templateUrl: './bgsch-create-abschl-2.component.html',
    styleUrls: ['./bgsch-create.component.less'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BuergschaftCreateComponentAbschl2 extends BuergscheinCreateSuper {

    @Input()
    model: CreateBuergscheinModel = new CreateBuergscheinModel();

    urlBuergscheinAntragBedingungenPdf = '';

    constructor(private readonly configurationApiService: ConfigurationApiService) {
        super();

        this.configurationApiService.getConfiguration().subscribe(configuration => {
            this.urlBuergscheinAntragBedingungenPdf = configuration.urlBuergscheinAntragBedingungenPdf;
        });
    }

}
